import {StringUtils} from '../../utils/string.utils';
import {ApiJsonResult} from '../../utils/api/apijsonresult';

export class ActivityTracker {
    id: number;
    scopeProgramId: number;
    childProgressLevelTrackerId: number;
    childActivityMasterJson: string;
    byParent: string;
    byTherapist: string;
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: any;

    static populate(jsonObject: any): ActivityTracker {
        let obj = new ActivityTracker();
        obj.id = jsonObject.id;
        obj.scopeProgramId = jsonObject.scopeProgramId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.childActivityMasterJson = jsonObject.childActivityMasterJson;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static formPopulate(obj: ActivityTracker, jsonObject: any): ActivityTracker {
        if (obj == null) {
            obj = new ActivityTracker();
        }
        obj.id = jsonObject.id;
        obj.scopeProgramId = jsonObject.scopeProgramId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.childActivityMasterJson = jsonObject.childActivityMasterJson;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): ActivityTracker {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            let jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = ActivityTracker.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): ActivityTracker [] {
        let lst: ActivityTracker [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            let jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(ActivityTracker.populate(jsonObject[i]));
            }
            return lst;
        }
    }

}
